import React from 'react'
import SeminarPastList from 'components/seminar/SeminarPastList'

const SeminarPast = ({ data }) => {
  return (
    <>
      {data.length === 0 ? null : (
        <div className="seminarPast">
          <h2 className="seminarPast__heading2">セミナー一覧</h2>
          <SeminarPastList data={data} />
        </div>
      )}
    </>
  )
}

export default SeminarPast
